import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

export const LinksTitleLoader = () => {
    const { gray200 } = colors;

    return (
        <Skeleton
            data-testid="links-title-loader"
            variant="rectangular"
            width={110}
            height={20}
            css={css({
                background: gray200,
                borderRadius: "6px"
            })}
        />
    );
};
